import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import {
  CRUD_ENTITY_CONFIGS,
  CRUD_ENTITY_ORDER,
  type CrudEntityKey,
  type CrudRecord
} from '../../core/config/entity-config';
import { DataStoreService } from '../../core/services/data-store.service';

@Component({
  selector: 'app-reports-page',
  imports: [CommonModule, RouterLink, CurrencyPipe],
  templateUrl: './reports-page.component.html',
  styleUrl: './reports-page.component.css'
})
export class ReportsPageComponent {
  protected readonly entityOrder = CRUD_ENTITY_ORDER;
  protected readonly entityConfigs = CRUD_ENTITY_CONFIGS;

  constructor(private readonly dataStoreService: DataStoreService) {}

  getCount(entity: CrudEntityKey): number {
    return this.dataStoreService.getCollectionCount(entity);
  }

  getLatestRecord(entity: CrudEntityKey): CrudRecord | null {
    return this.dataStoreService.getRecords(entity)[0] ?? null;
  }

  getOrderValue(): number {
    return this.dataStoreService
      .getRecords('orders')
      .reduce((total, record) => total + Number(record['amount'] ?? 0), 0);
  }
}